/* assets/z__minicart_open.js
   Open minicart from any button/link with:
   - data-open-minicart
   - or href="#minicart"
*/

(() => {
  "use strict";

  const openMiniCart = () => {
    // 1) méthode native du thème (la meilleure)
    const mc = document.querySelector("mini-cart");
    if (mc && typeof mc.open === "function") {
      mc.open();
      return true;
    }

    // 2) fallback: on force <details> open
    const details = document.querySelector("#bud-mini-cart-details");
    if (details) {
      details.setAttribute("open", "");
      return true;
    }

    console.warn("[minicart] mini-cart / details introuvable");
    return false;
  };

  // Delegation: marche même si le DOM est rerendu par Shopify
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-open-minicart], a[href='#minicart']");
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();
    openMiniCart();
  });

  // Optionnel: exposer une fonction globale (pratique pour tests)
  window.BUD_openMiniCart = openMiniCart;
})();
